var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAvatar = function SvgAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.4444V155.556C0 166.25 8.65278 175 19.4444 175H155.556C166.25 175 175 166.25 175 155.556V19.4444C175 8.75 166.25 0 155.556 0H19.4444C8.65278 0 0 8.75 0 19.4444ZM116.667 58.3333C116.667 74.4722 103.639 87.5 87.5 87.5C71.3611 87.5 58.3333 74.4722 58.3333 58.3333C58.3333 42.1944 71.3611 29.1667 87.5 29.1667C103.639 29.1667 116.667 42.1944 116.667 58.3333ZM29.1667 136.111C29.1667 116.667 68.0556 105.972 87.5 105.972C106.944 105.972 145.833 116.667 145.833 136.111V145.833H29.1667V136.111Z",
    fill: "#BDBDBD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAvatar);
export default ForwardRef;